
import Vue from 'vue';
import AthleteSideNav from '../components/navigation/AthleteSideNav.vue';
import AppBar from '../components/navigation/AppBar.vue';
import Footer from '../components/navigation/Footer.vue';
import { userStore } from '@/store';
import SystemNotifications from '@/components/notifications/SystemNotifications.vue';

export default Vue.extend({
	components: { AppBar, AthleteSideNav, SystemNotifications, Footer },
	data(){
		return {
			showSideNav: true,
		};
	},
	created(){
		if(this.CollapseSideNav) this.showSideNav = false;
	},
	computed: {
		CollapseSideNav(){
			return this.$vuetify.breakpoint.mobile;
		},
		ShowSystemBar(): boolean{
			return this.$slots['system-bar'] !== undefined;
		},
		CurrentAthleteId(): string{
			return userStore.athleteId;
		},
		UseFullscreen(): boolean{
			return this.$route.meta.useFullscreen ===  true;
		},
	}
});
